// Mock factories for cross-section / schematic geometry codes.
// Each builder returns the shape consumed by the corresponding internal
// output component (B6, B7, B9, B10, B11, B12, B13, B14, B15). Values are
// placeholders only; the goal is for the React component to mount and
// render without throwing.

const baseGlobalVariables = {
    river: 'Main River',
    reach: 'Reach 1',
    profile: '100yr',
};

export const crossSectionMocks = {
    // ---------------- B6 ----------------
    'XS 01': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XS 01',
                cumm_error: 12.5,
                data: [
                    {cross_section: 'RS 12345', channel: 250.0, error: 1.5},
                    {cross_section: 'RS 12200', channel: 145.2, error: -0.8},
                    {cross_section: 'RS 12050', channel: 150.0, error: 2.3},
                ],
            }],
        },
    }),
    'XS 02': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XS 02',
                data: [
                    {cross_section: 'RS 12345', chn: 250.0, LOB_OBRL: '1.85', ROB_OBRL: '0.92'},
                    {cross_section: 'RS 12200', chn: 145.2, LOB_OBRL: '-2.10', ROB_OBRL: '1.10'},
                    {cross_section: 'RS 12050', chn: 150.0, LOB_OBRL: '0.95', ROB_OBRL: '-1.75'},
                ],
            }],
        },
    }),
    'XS 03': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XS 03',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                    {cross_section: 'RS 12050'},
                ],
            }],
        },
    }),

    // ---------------- B7 ----------------
    'ST 02': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'ST 02',
                data: [
                    {
                        cross_section: 'RS 12345',
                        messages: [
                            {missing_methods: ['Energy', 'Pressure'], missing_values: ['Cd = 0.6', 'k = 0.5']},
                            {missing_methods: ['Yarnell'], missing_values: []},
                        ],
                    },
                    {
                        cross_section: 'RS 12200',
                        messages: [
                            {missing_methods: [], missing_values: ['Cd = 0.6']},
                        ],
                    },
                ],
            }],
        },
    }),
    'ST 03': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'ST 03',
                data: [
                    {cross_section: 'RS 12345', ratio: 0.95},
                    {cross_section: 'RS 12200', ratio: 0.92},
                    {cross_section: 'RS 12050', ratio: undefined},
                ],
            }],
        },
    }),
    'ST 04': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'ST 04',
                data: [
                    {cross_section: 'RS 11800', ratio: 0.90},
                    {cross_section: 'RS 11700', ratio: 0.88},
                ],
            }],
        },
    }),

    // ---------------- B9 ----------------
    'XY 01': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 01',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                    {cross_section: 'RS 12050'},
                ],
            }],
        },
    }),
    'XY 16': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 16',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                ],
            }],
        },
    }),

    // ---------------- B10 ----------------
    'XY 02': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 02',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                    {cross_section: 'RS 12050'},
                ],
            }],
        },
    }),
    'XY 14': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 14',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                ],
            }],
        },
    }),

    // ---------------- B11 ----------------
    'XCL 01': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XCL 01',
                cross_section: 'RS 12345',
                data: [],
            }],
        },
    }),
    'XY 03': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 03',
                data: [
                    {cross_section: 'RS 12345', ratio: 1.12, skew: 15, marked: true},
                    {cross_section: 'RS 12200', ratio: 1.05, skew: null, marked: false},
                    {cross_section: 'RS 12050', ratio: 0.97, skew: 20, marked: true},
                ],
            }],
        },
    }),
    'XY 04': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 04',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                ],
            }],
        },
    }),

    // ---------------- B12 ----------------
    'SKW 00': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'SKW 00',
                data: [],
            }],
        },
    }),
    'XY 17': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 17',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                ],
            }],
        },
    }),
    'XY 05': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 05',
                data: [
                    {cross_section: 'RS 12345', skew: 18, defined_skew: 15, defined_skew_in_range: true},
                    {cross_section: 'RS 12200', skew: -22, defined_skew: 10, defined_skew_in_range: false},
                    {cross_section: 'RS 12050', skew: 25, defined_skew: null, defined_skew_in_range: false},
                ],
            }],
        },
    }),
    'XY 06': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 06',
                data: [
                    {cross_section: 'RS 11900 BR', skew: 17, skew_map: '20', defined_skew: 18, defined_skew_in_range: true},
                    {cross_section: 'RS 11500 BR', skew: 28, skew_map: null, defined_skew: 15, defined_skew_in_range: false},
                ],
            }],
        },
    }),
    'XY 07': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 07',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                ],
            }],
        },
    }),
    'XY 08': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 08',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                    {cross_section: 'RS 12050'},
                ],
            }],
        },
    }),
    'XY 09': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 09',
                data: [
                    {cross_section: 'RS 11900 BR'},
                    {cross_section: 'RS 11500 BR'},
                ],
            }],
        },
    }),

    // ---------------- B13 ----------------
    'FW 04': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'FW 04',
                data: [],
            }],
        },
    }),
    'FW 05': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'FW 05',
                data: [
                    {cross_section: 'RS 12345', yr100: 1500, fw: 1500},
                    {cross_section: 'RS 12200', yr100: 2100, fw: 2050},
                    {cross_section: 'RS 12050', yr100: 2400, fw: 2350},
                ],
            }],
        },
    }),
    'FW 06': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'FW 06',
                data: [
                    {
                        cross_section: 'RS 12345',
                        YR100: {dn_text: 'Normal Depth', dn_value: 0.005},
                        FW: {dn_text: 'Normal Depth', dn_value: 0.005},
                    },
                    {
                        cross_section: 'RS 12050',
                        YR100: {dn_text: 'Known WS', dn_value: 105.2},
                        FW: {dn_text: 'Normal Depth', dn_value: 0.004},
                    },
                ],
            }],
        },
    }),

    // ---------------- B14 ----------------
    'XS 04': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XS 04',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                    {cross_section: 'RS 12050'},
                ],
            }],
        },
    }),

    // ---------------- B15 ----------------
    'XY 10': (messageKey) => ({
        message_key: messageKey,
        data: {
            global_variables: {...baseGlobalVariables},
            result: [{
                error_id: 'XY 10',
                data: [
                    {cross_section: 'RS 12345'},
                    {cross_section: 'RS 12200'},
                ],
            }],
        },
    }),
};
